export const visit = (vm, at) => {
vm(require("marketplace-ui-install/lang/en.lyaml"));
vm(require("marketplace-embed/lang/en.lyaml"));
at({ "en": { "marketplace-embed-ba": { "cta": { "open": "Open" } } } });
};